module.exports = __webpack_public_path__ + "img/BIT_white19.2ae6f6b2.jpg";